import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import api from "@/lib/axios"
import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { useState } from "react"
import { Loader2 } from "lucide-react"
import toast from "react-hot-toast"
import { AxiosError } from "axios"
import { getListPeriode, getListUnitkerja } from "@/services/getData"
import { MultiSelect } from "@/components/ui/multi-select"
import { Periode, Unitkerja } from "@/types"
import { MdOutlineSync } from "react-icons/md"

// const postData = async (newData: { id_sys_periode: string }) => {
//   const response = await api.post("/setting/verifikator-kepemimpinan/rekap", newData);
//   return response.data;
// };

const postData = async (newData: {
  id_sys_periode: string
  list_uk_id: string[]
}) => {
  const response = await api.post(
    "/setting/verifikator-kepemimpinan/rekap-per-prodi",
    newData
  )
  return response.data
}

export default function Form({ closeModal }: { closeModal: () => void }) {
  const { data: dataPeriode } = useQuery({
    queryKey: ["listPeriode"],
    queryFn: () => getListPeriode(),
    select: (data) =>
      data?.map((periode: Periode) => ({
        label: `${periode.jalur_jenis?.nama_jalur_jenis}-${periode.tahun} Gelombang ${periode.gelombang}`,
        value: periode.id_sys_periode,
      })),
  })

  const { data: listUnitkerja } = useQuery({
    queryKey: ["listUnitkerja"],
    queryFn: getListUnitkerja,
  })

  const listProdi = listUnitkerja
    ?.filter((unitkerja: Unitkerja) => {
      return (
        unitkerja.unitkerja_group_key == "5" &&
        unitkerja.is_active &&
        (unitkerja.uk_program == "S1" ||
          unitkerja.uk_program == "D4" ||
          unitkerja.uk_program == "D3")
      )
    })
    .map((unitkerja: Unitkerja) => ({
      label: unitkerja.nama,
      value: unitkerja.uk_id,
    }))

  const [selectedPeriodes, setSelectedPeriodes] = useState<string[]>([])
  const [selectedProdis, setSelectedProdis] = useState<string[]>([])

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: postData,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listRekapPesertaKepemimpinan"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    mutate({
      id_sys_periode: selectedPeriodes.join(","),
      list_uk_id: selectedProdis,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader
        icon={<MdOutlineSync />}
        title={"Generate Rekap Peserta Validasi Kepemimpinan"}
      />
      <div>
        <Label>Periode</Label>
        <MultiSelect
          options={dataPeriode || []}
          onValueChange={(value) => {
            setSelectedPeriodes(value)
          }}
          defaultValue={selectedPeriodes}
          placeholder="Pilih Periode"
          variant="inverted"
          animation={2}
          maxCount={3}
        />
      </div>
      <div>
        <Label>Prodi</Label>
        <MultiSelect
          options={listProdi || []}
          onValueChange={(value) => {
            setSelectedProdis(value)
          }}
          defaultValue={selectedProdis}
          placeholder="Pilih Prodi"
          variant="inverted"
          animation={2}
          maxCount={3}
        />
      </div>

      <Button className="mt-3 flex items-center gap-3" disabled={isPending}>
        {isPending ? (
          <>
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
            Processing...
          </>
        ) : (
          "Generate"
        )}
      </Button>
    </form>
  )
}
